import { navImages } from "./image-definitions"
import AddFeed from "../components/feed/AddFeed"
import Clusters from "../components/clusters/Clusters"
import Communities from "../components/communities/Communities"
import Dashboard from "../components/dashboard/Dashboard"
import FeedComponent from "../components/feed/FeedComponent"
import InsightAreas from "../components/insight-areas/InsightAreas"
import KeyIssues from "../components/key-issues/KeyIssues"
import Sources from "../components/sources/Sources"
import Stakeholders from "../components/stakeholders/Stakeholders"
import Users from "../components/users/Users"
import Notifications from "../components/notifications/Notifications"

const {
    dashboard,
    feed,
    clusters,
    sources,
    insightAreas,
    keyIssues,
    communities,
    users,
    stakeholders,
    notifications,
} = navImages

export default [
    {
        label: "Dashboard",
        activeIcon: dashboard.active,
        icon: dashboard.inactive,
        path: "/home",
        link: "/home",
        permissionsRequired: ["r_dashboard_home"],
        component: Dashboard,
    },
    {
        switch: [
            {
                path: "/knowledge/add",
                permissionsRequired: ["w_dashboard_feed"],
                component: AddFeed,
            },
            {
                label: "Feed",
                activeIcon: feed.active,
                icon: feed.inactive,
                path: "/knowledge/:id?",
                link: "/knowledge",
                iconStyles: {
                    marginTop: "-5.5px",
                },
                permissionsRequired: ["r_dashboard_feed"],
                component: FeedComponent,
            },
        ],
        path: "/knowledge",
    },
    {
        label: "Clusters",
        activeIcon: clusters.active,
        icon: clusters.inactive,
        path: "/clusters/:id?",
        link: "/clusters",
        iconStyles: {
            marginTop: "-5.5px",
        },
        permissionsRequired: ["r_cluster"],
        component: Clusters,
    },
    {
        label: "Sources",
        activeIcon: sources.active,
        icon: sources.inactive,
        path: "/sources/:id?",
        link: "/sources",
        iconStyles: {
            marginTop: "-5.5px",
        },
        permissionsRequired: ["r_source"],
        component: Sources,
    },
    {
        label: "Insight Areas",
        activeIcon: insightAreas.active,
        icon: insightAreas.inactive,
        path: "/insight-areas/:id?",
        link: "/insight-areas",
        permissionsRequired: ["r_topic"],
        component: InsightAreas,
    },
    {
        label: "Key Issues",
        activeIcon: keyIssues.active,
        icon: keyIssues.inactive,
        path: "/key-issues/:id?",
        link: "/key-issues",
        iconStyles: {
            marginTop: "-6px",
        },
        permissionsRequired: ["r_dimension"],
        component: KeyIssues,
    },
    {
        label: "Stakeholders",
        activeIcon: stakeholders.active,
        icon: stakeholders.inactive,
        path: "/stakeholders/:id?",
        link: "/stakeholders",
        permissionsRequired: ["r_stakeholder"],
        component: Stakeholders,
    },
    {
        label: "Communities",
        activeIcon: communities.active,
        icon: communities.inactive,
        path: "/communities/:id?",
        link: "/communities",
        iconStyles: {
            marginTop: "-4px",
        },
        permissionsRequired: ["w_community"],
        component: Communities,
    },
    {
        label: "Users",
        activeIcon: users.active,
        icon: users.inactive,
        path: "/users/:id?",
        link: "/users",
        permissionsRequired: ["r_user"],
        component: Users,
    },
    {
        label: "Notifications",
        activeIcon: notifications.active,
        icon: notifications.inactive,
        path: "/notifications/:id?",
        link: "/notifications",
        permissionsRequired: ["r_user"],
        component: Notifications,
    },
]
